export const paginationSize = 10;
export const paginationPageSizeOptions = ["10", "20", "30", "40", "50", "100"];

export const paginationSizeMOT = 50;
export const paginationPageSizeOptionsMOT = ["50", "100", "150", "200"];

export const FETCH_POLICY_NETWORK_ONLY = "network-only";

export default {paginationSize, paginationPageSizeOptions};
